import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, connectAuthEmulator } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';

// Firebase configuration
// Note: For production, move these to .env file for better security
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBN5rJEzELOI1s8M9P1H62W1R1RmxW4V9o",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "nuroleap-production.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "nuroleap-production",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "nuroleap-production.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "313205161514",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:313205161514:web:c69711c1f322fe430f0d53",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-SPMCMN8BDD"
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

// Solo inicializar Firebase Web SDK si NO es plataforma nativa
if (!Capacitor.isNativePlatform()) {
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    // Connect to emulator in development if needed
    if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
      connectAuthEmulator(auth, 'http://localhost:5173', { disableWarnings: true });
    }
  } else {
    app = getApps()[0];
    auth = getAuth(app);
  }
}

export { app, auth };
export default app;

